import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Avatar,
  Form,
  Input,
  Button,
  Spin,
  Tag,
  Card,
  Statistic,
  Select,
  message
} from "antd";
import {
  UserOutlined,
  DeploymentUnitOutlined
} from "@ant-design/icons";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function OperationsDetails() {
  const { id } = useParams();
 
   const navigate = useNavigate();

  // Auth info
  const token = localStorage.getItem("token");
  const fullName = localStorage.getItem("fullName");
  const role = (localStorage.getItem("role") || "").toUpperCase();

  useEffect(() => {
    if (!token || !fullName || !role) {
      navigate("/user/sign_in");
    }
  }, [token, fullName, role, navigate]);


  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [form] = Form.useForm();
  const currentStatus = Form.useWatch("OperationsStatus", form);
   const [saving, setSaving] = useState(false);

  const getStatusColor = (status) => {
    switch (status) {
      case "ACTIVE":
        return "green";
      case "INACTIVE":
        return "red";
      case "SUSPENDED":
        return "orange";
      default:
        return "default";
    }
  };

  useEffect(() => {
    const loadOperations = async () => {
      try {
        setLoading(true);

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/user/operations/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data.success) {
          setUser(res.data.data);
          form.setFieldsValue(res.data.data);
        }

      } finally {
        setLoading(false);
      }
    };

    loadOperations();
  }, [id, token, form]);

 

  if (loading)
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-100">
        <Spin size="large" />
      </div>
    );

  if (!user)
    return (
      <div className="flex items-center justify-center min-h-screen">
        Operations user not found
      </div>
    );

   

const handleUpdateOperations = async () => {
  try {
    setSaving(true);

    const values = await form.validateFields();

    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/user/operations/update`,
      {
        Email: user.Email,
        ...values
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (response.data.success) {
      toast.success("Operations updated successfully 🚀");
      setUser(response.data.data);
    } else {
      toast.error(response.data.message);
    }

  } catch (error) {
    toast.error(error?.response?.data?.message || "Update failed ❌");
  } finally {
    setSaving(false);
  }
};

  return (
    <div className="min-h-screen bg-slate-100">

       <ToastContainer
              position="bottom-left"
              autoClose={5000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
              className="!mb-6 !ml-4"
              toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
            />

      {/* ===== TOP PROFILE BANNER ===== */}
      <div className="px-10 py-12 m-4 text-white shadow-xl bg-gradient-to-r from-teal-600 to-cyan-700 rounded-3xl">

        <div className="flex flex-col items-center gap-6 md:flex-row">

          <Avatar
            size={120}
            src={user.ProfilePhotoUrl}
            icon={<UserOutlined />}
            className="border-4 border-white shadow-lg"
          />

          <div>
            <h1 className="text-3xl font-bold">
              {user.FullName}
            </h1>

            <p className="opacity-90">
              {user.Email}
            </p>

            <div className="flex gap-3 mt-4">
              <Tag color="cyan" className="font-semibold">
                {user.Role}
              </Tag>

              <Tag color={getStatusColor(user.OperationsStatus)}>
                {user.OperationsStatus || "ACTIVE"}
              </Tag>
            </div>
          </div>

        </div>
      </div>

      <div className="px-10 py-10">

        {/* KPI */}
        <div className="mb-10">
          <Card className="border-0 shadow-md rounded-3xl">
            <Statistic
              title="Courses Currently Operating"
              value={user.CourcesOperating || 0}
              prefix={<DeploymentUnitOutlined />}
            />
          </Card>
        </div>

        {/* FORM */}
        <div className="p-10 bg-white shadow-lg rounded-3xl">

          <h2 className="mb-8 text-2xl font-semibold text-slate-800">
            Operations Account Settings
          </h2>

          <Form form={form} layout="vertical">

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

              <Form.Item name="FullName" label="Full Name">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="Email" label="Email">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="PhoneNumber" label="Phone Number">
                <Input size="large" />
              </Form.Item>

              <Form.Item name="Country" label="Country">
                <Input size="large" />
              </Form.Item>

            {/* 🔥 Current Status Display */}
<div className="mb-4">
  <span className="mr-3 text-sm font-semibold text-gray-600">
    Current Status:
  </span>

  <Tag
    color={getStatusColor(currentStatus)}
    className="px-3 py-1 text-sm font-semibold rounded-full"
  >
    {currentStatus || "ACTIVE"}
  </Tag>
</div>

{/* 🔥 Editable Status */}
<Form.Item
  name="OperationsStatus"
  label="Change Account Status"
>
  <Select size="large">
    <Select.Option value="ACTIVE">ACTIVE</Select.Option>
    <Select.Option value="INACTIVE">INACTIVE</Select.Option>
    <Select.Option value="SUSPENDED">SUSPENDED</Select.Option>
  </Select>
</Form.Item>

            </div>

            <Button
  type="primary"
  size="large"
  loading={saving}
  onClick={handleUpdateOperations}
  className="px-12 mt-10 !bg-teal-600 hover:!bg-teal-700 rounded-xl font-semibold"
>
  Update Operations
</Button>

          </Form>

        </div>

      </div>
    </div>
  );
}

export default OperationsDetails;